import React from 'react';

// Styles
import styles from './CreatePoll.module.css';

// Components
import CreatePollForm from '../CreatePollForm/CreatePollForm';
import FormQuestions from '../FormQuestions/FormQuestions';

// Interfaces
import { Poll } from '../../../interfaces/Poll';
import { PollDispatch } from '../../../interfaces/Reducers';

// Language
import { useTranslation } from 'react-i18next';


interface Props {
    poll: Poll
    create: boolean
    inputErrorIDs: string[]
    dispatchPoll: React.Dispatch<PollDispatch>
    children: React.ReactNode
}

const CreatePoll: React.FC<Props> = ({ poll, create, inputErrorIDs, dispatchPoll, children }) => {

    const { t } = useTranslation();

    const errorQuestions = inputErrorIDs.includes('questions_needed') && poll.questions?.length === 0;


    return (
        <div className={styles.createPollContainer}>
            <h1>{t(create ? 'create_poll' : 'edit_poll')}</h1>
            <div className={styles.createPollForm}>
                <CreatePollForm
                    inputErrorIDs={inputErrorIDs}
                    poll={poll}
                    dispatchPoll={dispatchPoll}
                />
                <div className={styles.verticalLine} />
                <FormQuestions
                    hasTable={poll.has_table || false}
                    questions={poll.questions || []}
                    dispatchPoll={dispatchPoll}
                    error={errorQuestions}
                />
            </div>
            {children}
        </div>
    );
};

export default CreatePoll;